"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseLayersControl = void 0;
var _Fab2 = _interopRequireDefault(require("@mui/material/Fab"));
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _LayersOutlined2 = _interopRequireDefault(require("@mui/icons-material/LayersOutlined"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireWildcard(require("react"));
var _client = require("react-dom/client");
var _reactI18next = require("react-i18next");
var _styledComponents = require("styled-components");
var _hooks = require("../../hooks");
var _layersDrawer = require("./layers-drawer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const id = 'layers-control';
class BaseLayersControl {
  constructor(options, callback) {
    this.options = options;
    this.callback = callback;
  }
  onAdd(_map) {
    this.map = _map;
    this.container = document.createElement('div');
    this.container.className = 'maplibregl-ctrl';
    const content = document.createElement('div');
    content.id = id;
    this.container.appendChild(content);
    return this.container;
  }
  init(theme, options = {}) {
    this.theme = theme;
    this.update(options);
  }
  update(options = {}, callback) {
    if (!this.theme) return;
    const {
      baseLayer,
      baseLayers,
      baseLayersPlacement
    } = this.options = {
      ...this.options,
      ...options
    };
    if (callback) this.callback = callback;
    const ele = document.getElementById(id);
    if (!ele) return;
    if (!this.root) this.root = (0, _client.createRoot)(ele);
    this.root.render(/*#__PURE__*/_react.default.createElement(BaseLayerControl, {
      baseLayers: baseLayers,
      baseLayersPlacement: baseLayersPlacement,
      onSelect: this.callback,
      selectedBaseLayer: baseLayer,
      theme: this.theme
    }));
  }
  onRemove() {
    this.container?.parentNode?.removeChild(this.container);
    this.map = undefined;
  }
}
exports.BaseLayersControl = BaseLayersControl;
function BaseLayerControl({
  theme,
  baseLayers,
  baseLayersPlacement,
  selectedBaseLayer,
  onSelect
}) {
  const [tooltipOpen, toggleTooltip] = (0, _react.useState)(null);
  const [buttonsShowed, showButtons] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, baseLayersPlacement === 'top-right' ? /*#__PURE__*/_react.default.createElement(TopWrapper, null, /*#__PURE__*/_react.default.createElement(StyledFab, {
    onClick: () => showButtons(!buttonsShowed),
    size: "medium"
  }, /*#__PURE__*/_react.default.createElement(_LayersOutlined2.default, {
    color: "primary"
  })), /*#__PURE__*/_react.default.createElement(ColumnWrapper, {
    sx: {
      display: buttonsShowed ? 'flex' : 'none'
    }
  }, (baseLayers || _layersDrawer.defaultBaseLayers).map(key => /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    key: key,
    onClose: () => toggleTooltip(null),
    onOpen: () => toggleTooltip(key),
    open: tooltipOpen === key,
    placement: "left",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: _hooks.baseLayersMap[key].labelKey
    })
  }, /*#__PURE__*/_react.default.createElement(StyledButton, {
    className: key === selectedBaseLayer ? 'selected' : '',
    onClick: () => {
      if (key !== selectedBaseLayer) {
        toggleTooltip(null);
        onSelect(key);
      }
    }
  }, /*#__PURE__*/_react.default.createElement(StyledBaseLayerThumbail, {
    src: _layersDrawer.baseLayersThumbnails[key]
  })))))) : /*#__PURE__*/_react.default.createElement(Wrapper, null, (baseLayers || _layersDrawer.defaultBaseLayers).map(key => /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    key: key,
    onClose: () => toggleTooltip(null),
    onOpen: () => toggleTooltip(key),
    open: tooltipOpen === key,
    placement: "top",
    title: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: _hooks.baseLayersMap[key].labelKey
    })
  }, /*#__PURE__*/_react.default.createElement(StyledButton, {
    className: key === selectedBaseLayer ? 'selected' : '',
    onClick: () => {
      if (key !== selectedBaseLayer) {
        toggleTooltip(null);
        onSelect(key);
      }
    }
  }, /*#__PURE__*/_react.default.createElement(StyledBaseLayerThumbail, {
    src: _layersDrawer.baseLayersThumbnails[key]
  })))))));
}
const TopWrapper = _styledComponents.styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
`;
const Wrapper = _styledComponents.styled.div`
  display: flex;

  > *:not(:first-child) {
    margin-left: 4px;
  }
`;
const ColumnWrapper = (0, _styledComponents.styled)(_Box2.default)`
  flex-direction: column;
  gap: 8px;
  background-color: white;
  padding: 8px;
  border-radius: 8px;
`;
const StyledButton = (0, _styledComponents.styled)(_ButtonBase2.default)`
  && {
    border: 1px solid #555;
    border-radius: 8px;
    padding: 1px;

    &.selected {
      border: 1px solid ${({
  theme
}) => theme.palette.primary.main};
    }
  }
`;
const StyledBaseLayerThumbail = _styledComponents.styled.img`
  border-radius: 6px;
  height: 32px;
  width: 32px;
`;
const StyledFab = (0, _styledComponents.styled)(_Fab2.default)`
  && {
    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary) {
      background-color: #fff;
    }

    &:not(:disabled):not(.MuiFab-primary):not(.MuiFab-secondary):hover {
      background-color: #d5d5d5;
    }

    &.MuiFab-primary:hover {
      background-color: ${({
  theme
}) => theme.palette.primary.dark};
    }

    &.MuiFab-secondary:hover {
      background-color: ${({
  theme
}) => theme.palette.secondary.dark};
    }
  }
`;